import React, { FC, useCallback, useEffect, useState, useContext } from 'react';
import { get, post } from "../fetchers/fetchers";
import { get_query } from '../stateManagement/data';
import { useParams } from "react-router";

import {
    IconButton,
    Table,
    TableCell,
    TableHead, Typography,

} from "@material-ui/core";
import {
    IAdequacy,
    IControlMeasure,
    IControlMeasureCost, IFailureModeAssessment, IControlMeasureConcern,
    IProjectFailureMode

} from "../types/types";

import SocietalConcern from "./societal_concern";


import { TasksContext, TasksDispatchContext, TasksProvider, useTask } from '../stateManagement/context';


import { getControlMeasureConcern } from "../stateManagement/data";
import { API_URL } from "../env";

interface IControlMeasureAdequaciesProps {
    existing: boolean
}

interface IRouteParams {
    id: string
}



const SoceitalConcerns: FC<IControlMeasureAdequaciesProps> = ({ existing }) => {

    let dispatch = useContext(TasksDispatchContext)
    let tasks = useTask()


    const [isLoaded, setIsLoaded] = useState<boolean>(true);
    const [controlMeasureConcern, setControlMeasureConcern] = useState<IControlMeasureConcern[]>([]);
    const [failureModes, setFailureModes] = useState<IProjectFailureMode[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [adequacies, setAdequacies] = useState<IAdequacy[]>([]);
    const [reloadAdequacies, setReloadAdequacies] = useState<boolean>(false);
    const [failureModeAssessments, setFailureModeAssessments] = useState<IFailureModeAssessment[]>([]);

    useEffect(() => {

        if (tasks.loaded) {

            setFailureModes(tasks.failureModes)
            setFailureModeAssessments(tasks.failureModeAssessments)
            setAdequacies(tasks.adequacies)
            setControlMeasureConcern(tasks.controlMeasureConcern)
        }

    })



    const params = useParams<IRouteParams>()


    const getCMeasureConcern = (cm: IProjectFailureMode): IControlMeasureConcern => {

        if (!cm.id)
            throw new Error("IProjectFailureMode.id needs to be set")
        let ca = controlMeasureConcern.find(ca => ca.project_failure_mode_id === cm.id)

        if (ca) {
            return ca
        }
        ca = {
            project_failure_mode_id: cm.id

        }
        return ca
    }

    const postControlMeasureConcern = async (controlMeasureConcern: IControlMeasureConcern) => {
        delete controlMeasureConcern.id
        delete controlMeasureConcern.concern
        delete controlMeasureConcern.risk_of_concern
        delete controlMeasureConcern.risk_to_society

        // check if states in params
        let query_params = get_query()

        // check if state key in params
        if (query_params.state) {
            controlMeasureConcern["state_id"] = parseInt(query_params.state)
        }

        let d = await post<IControlMeasureConcern>(API_URL + "control_measures/" + params.id.toString() + "/control_measure_concern", controlMeasureConcern);
        let e = await getControlMeasureConcern(params.id, dispatch)
    }

    const updateControlMeasuresConcern = useCallback((controlMeasureConcern: IControlMeasureConcern) => {

        postControlMeasureConcern(controlMeasureConcern).then(() => {
            setReloadAdequacies(true);
        })
    }, [setControlMeasureConcern, setIsLoaded]);



    return (<>
        <Table>
            <TableHead>
                <TableCell></TableCell>
                <TableCell>Priority Failure Mode</TableCell>
                <TableCell>Significant Risk to Society</TableCell>
                <TableCell>Risk of Concern Characteristics</TableCell>
                <TableCell>Societal Concern Rating</TableCell>
                <TableCell width={"40%"}>Assessment</TableCell>
                <TableCell>Comments</TableCell>
            </TableHead>

            {isLoaded && failureModes.map((f) => {
                if (f.failure_mode?.is_active === false) { return <></> }
                let fma = failureModeAssessments.find(fma => fma.project_failure_mode_id === f.id)
                if (!fma) { return <></> }
                if (fma.consider) {
                    return <SocietalConcern
                        control_measure_concern={getCMeasureConcern(f)}
                        project_failure_mode={f}
                        updateControlMeasuresConcern={updateControlMeasuresConcern}
                        adequacies={adequacies} />

                } else {
                    return <></>
                }


            })}
            
        </Table>
        <div>
            <Typography><small>Note only included group failure modes are shown</small></Typography>
        </div>
    </>


    );
}

export default SoceitalConcerns;
